import { debounce } from 'lodash'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import FilterBar from '@modules/admin/shared/FiltersBar'
import Loading from '@modules/core/components/Loading'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectField from '@modules/formFields/SelectField'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'
import BooleanCell from '@modules/tableComponents/Cell.Boolean'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Consultations from '@services/Consultations'
import { history as browserHistory } from '@services/History'
import { twoMinutesToString } from '../../../../utilities/date'
import AccessControl from '../../../auth/AccessControl'
import IconComponent from '../../../core/icons/IconComponent'
import CustomPagination from '../../../tableComponents/Pagination'
import { changeProfessionalErrorToNull } from '../dux/professionalThunk'

class ScheduleIndexContainer extends Component {
  state = {
    professionals: null,
    page: null,
    lastPage: 1,
    pageSize: 50,
    isFetching: false,
    search: '',
    companyFilter: [],
    scheduleState: null,
  }

  client = Consultations.professional

  handleChangePage = (page) => {
    return this.setState({ page }, this.fetchProfessionals)
  }

  onTypeSearch = (search) => {
    return this.setState({ search, page: 1 }, this.debouncedFetch)
  }

  fetchProfessionals = () => {
    //TODO: ActiveFilter wont work on this endpoint
    const { page, pageSize } = this.state
    const filters = {
      search: this.state.search,
      on_duty: this.state.scheduleState !== null ? this.state.scheduleState.value : undefined,
      speciality_ids: this.state.specialityFilter ? this.state.specialityFilter.map((sp) => sp.id) : undefined,
      company_api_keys: this.state.companyFilter && this.state.companyFilter.map((co) => co.api_key),
    }

    this.setState({ isFetching: true })

    return this.client
      .index({ page, pageSize, ...filters, roleFilter: [4] })
      .then((response) => {
        return this.setState({
          professionals: response.data,
          page: response.meta.current_page,
          lastPage: response.meta.last_page,
          isFetching: false,
          total: response.meta.total,
        })
      })
      .catch((err) => {
        this.setState({ isFetching: false, professionals: [] })
        alert(err.message)
      })
  }

  debouncedFetch = debounce(this.fetchProfessionals, 350, false)

  handleOnClickAlertDismiss() {
    this.props.dispatch(changeProfessionalErrorToNull())
  }

  componentDidMount() {
    this.fetchProfessionals()
  }

  render() {
    const { professionals, isFetching, search, specialityFilter, companyFilter, scheduleState, total } = this.state
    const { t } = this.props
    return (
      <div>
        <DashboardHeader
          title={<Trans>Horarios</Trans>}
          total={total}
          className="crud-wrapper container-processing-wrapper"
        />

        <FilterBar onChange={this.onTypeSearch} value={search}>
          <SelectField
            options={[
              { name: t('Disponible'), value: 0 },
              { name: t('No disponible'), value: 1 },
            ]}
            valueKey="value"
            input={{
              value: scheduleState,
              onChange: (state) => this.setState({ scheduleState: state, page: 1 }),
            }}
            placeholder={t('Disponibilidad del Profesional')}
          />
          <AccessControl>
            <SelectCompanyField
              placeholder={t('Compañías')}
              multi
              input={{
                value: companyFilter,
                onChange: (company) => this.setState({ companyFilter: company, page: 1 }),
              }}
            />
          </AccessControl>

          <SelectSpecialityField
            placeholder={t('Especialidades')}
            multi
            input={{
              value: specialityFilter,
              onChange: (speciality) => this.setState({ specialityFilter: speciality, page: 1 }),
            }}
          />
        </FilterBar>

        <Loading isFetching={isFetching} />

        {professionals && (
          <div>
            <table className="DEPRECATED_list">
              <thead>
                <tr className="column">
                  <th>
                    <Trans>Nombre</Trans>
                  </th>
                  <th>
                    <Trans>Disponible</Trans>
                  </th>
                  <th>
                    <Trans>Lunes</Trans>
                  </th>
                  <th>
                    <Trans>Martes</Trans>
                  </th>
                  <th>
                    <Trans>Miércoles</Trans>
                  </th>
                  <th>
                    <Trans>Jueves</Trans>
                  </th>
                  <th>
                    <Trans>Viernes</Trans>
                  </th>
                  <th>
                    <Trans>Sábado</Trans>
                  </th>
                  <th>
                    <Trans>Domingo</Trans>
                  </th>
                </tr>
              </thead>
              <tbody>
                {professionals.map((professional, key) => (
                  <tr key={key} onClick={() => browserHistory.push(`/professional/${professional.id}/schedule`)}>
                    <td>{professional.name}</td>
                    <td>
                      <BooleanCell value={!professional.on_holidays} />
                    </td>

                    {professional.schedules.map((schedule, key) => (
                      <td key={key}>
                        <div className="container-fluid schedules-table">
                          <div className="row">
                            <div className="col-xs-10 schedule-day">
                              <div>{twoMinutesToString(schedule.start_first_period, schedule.end_first_period)}</div>
                              <div>{twoMinutesToString(schedule.start_second_period, schedule.end_second_period)}</div>
                            </div>
                            <div className="col-xs-2 schedule-active">
                              {schedule.active ? (
                                <IconComponent className="check" icon="check" />
                              ) : (
                                <IconComponent className="cross" icon="times" />
                              )}
                            </div>
                          </div>
                        </div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

            <CustomPagination
              onClickItem={(page) => this.handleChangePage(page)}
              activePage={this.state.page}
              totalPages={this.state.lastPage}
              maxButtons={7}
            />
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation()(connect()(ScheduleIndexContainer))
